import axios from 'axios'
import React, { useState } from 'react'
import {
  Accordion,
  AccordionItem,
  // AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/fancy-example.css'
import AwsConfig from '../../Config/AwsConfig'

function GptComponent(props) {
  const { inputData, setIsLoading } = props
  const { GptUrl } = AwsConfig
  const [gptValue, SetGptValue] = useState('')
  const ChatGpt = () => {
    let data = JSON.stringify({})
    if (gptValue) {
      data = JSON.stringify({
        prompt: 1,
        movieName: inputData.movieName,
        year: inputData.releaseDate.split('-')[0],
        mainActorName: inputData.Moviecast[0].name_En,
      })
      getData(data)
    } else {
      setIsLoading(true)
      data = JSON.stringify({
        prompt: 1,
        movieName: inputData.movieName,
        year: inputData.releaseDate.split('-')[0],
        mainActorName: inputData.Moviecast[0].name_En,
      })
      getData(data)
    }
  }

  const TranslateTextTetoEn = () => {
    let data = JSON.stringify({})
    if (gptValue) {
      setIsLoading(true)
      data = JSON.stringify({
        prompt: 3,
        translateText: gptValue,
      })
      getData(data)
    }
  }

  const TranslateTextEntoTe = () => {
    let data = JSON.stringify({})
    if (gptValue) {
      setIsLoading(true)
      data = JSON.stringify({
        prompt: 2,
        translateText: gptValue,
      })
      getData(data)
    }
  }

  const DisableGptButton = () =>
    inputData.movieName && inputData.releaseDate && inputData.Moviecast && (inputData.Moviecast.length >= 1)

  const getData = data => {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: GptUrl,
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    }

    axios
      .request(config)
      .then(response => {
        SetGptValue(response.data.data)
        setIsLoading(false)
      })
      .catch(error => {
        console.warn(error)
      })
  }

  return (
    <div style={{ marginTop: '10px' }}>
      <Accordion allowZeroExpanded>
        <AccordionItem>
          {/* <AccordionItemHeading> */}
          <AccordionItemButton>Gpt</AccordionItemButton>
          {/* </AccordionItemHeading> */}
          <AccordionItemPanel>
            <div style={{ marginTop: '10px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <button
                  onClick={() => ChatGpt()}
                  className='btn btn-primary'
                  type='button'
                  disabled={!DisableGptButton()}
                >
                  GetMovie Plot
                </button>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button
                    type='button'
                    onClick={() => TranslateTextEntoTe()}
                    className='btn btn-primary'
                    // style={{ float: 'right', marginRight: '20px' }}
                    disabled={!gptValue}
                  >
                    {'En=>Te'}
                  </button>
                  <button
                    type='button'
                    onClick={() => TranslateTextTetoEn()}
                    className='btn btn-primary'
                    // style={{ float: 'right' }}
                    disabled={!gptValue}
                  >
                    {'Te=>En'}
                  </button>
                </div>
              </div>
              <textarea
                className='rounded p-1'
                value={gptValue}
                style={{ width: '100%', marginTop: '10px' }}
                rows={12}
                cols={20}
                onChange={event => SetGptValue(event.target.value)}
              />
            </div>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  )
}

export default GptComponent
